// SettlementCutOffsTable.tsx
import React, { Component, Fragment } from "react";
import { Toast } from "primereact/toast";
import moment from "moment";
import { Column } from "primereact/column";
import history from "../../../history";
import { PagedResult } from "../../../models/Result";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import ExtendedDataTable from "../../../components/ExtendedDataTable";
import { SettlementCutOff } from "../../../models/IssuingClientsModel";



interface Props {
    loadApi: (searchRequest: SearchRequestBaseModel) => Promise<PagedResult<SettlementCutOff[]>>;
    detailsRoute: string;
    from?: string;
    to?: string;
}

interface State {
    settlements: SettlementCutOff[];
    isLoading: boolean;
    totalRecords: number;
}

export default class SettlementCutOffsTable extends Component<Props, State> {
    private toast: Toast | null = null;
    private dataTable: ExtendedDataTable | null = null;

    constructor(props: Props) {
        super(props);
        this.state = { settlements: [], isLoading: false, totalRecords: 0 };
    }
    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.from !== this.props.from ||
            prevProps.to !== this.props.to
        ) {
            // Reset table to first page and reload
            this.dataTable?.reset();
        }
    }
    loadSettlementData = async (searchRequest: SearchRequestBaseModel) => {
        this.setState({ isLoading: true });
        const result = await this.props.loadApi({ ...searchRequest, from: this.props.from, to: this.props.to });

        if (!result.success) {
            this.toast?.show({ severity: "error", summary: "Error", detail: result.message, life: 3000 });
        }

        this.setState({ settlements: result.data, totalRecords: result.totalCount, isLoading: false });
    };

    onSettlementDetailsClick = (row: SettlementCutOff) => {
        history.push(`${this.props.detailsRoute}/${row.id}`);
    };

    render() {
        return (
            <Fragment>
                <div>
                    <Toast ref={(el) => (this.toast = el)} />

                    <ExtendedDataTable
                        ref={(ref: any) => (this.dataTable = ref)}
                        value={this.state.settlements}
                        onChange={this.loadSettlementData}
                        loading={this.state.isLoading}
                        totalRecords={this.state.totalRecords}
                        defaultSortField={null}
                        defaultSortOrder={null}
                        onRowClick={(e: { data: SettlementCutOff }) => this.onSettlementDetailsClick(e.data)}
                    >
                        <Column {...({ alwaysVisible: true } as any)} field="settlementRequestId" header="Request ID" />
                        <Column {...({ alwaysVisible: true } as any)} field="settlementDate" header="Settlement Date" body={(row) => moment(row.settlementDate).format("DD/MM/YYYY")} />
                        <Column field="settlementCycle" header="Cycle" />
                        <Column field="settlementAmount" header="Amount" />
                    </ExtendedDataTable>

                </div>
            </Fragment>
        );
    }
}
